export default "__VITE_ASSET__CNj2470A__"